import { render, staticRenderFns } from "./WasteWaterWasteMainSection.vue?vue&type=template&id=b8597398"
import script from "./WasteWaterWasteMainSection.vue?vue&type=script&lang=js"
export * from "./WasteWaterWasteMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports